// Company-creation-wizard option data — placeholder until the real onboarding
// API lands. Labels are i18n keys (the wizard UI is bilingual). Icons are
// kebab-case lucide names.

import { CompanyEmployeeRange } from '@/api/endpoints/companyApi';

export interface OnboardingOption {
  id: string;
  labelKey: string;
  icon?: string;
}

// `id` doubles as the backend `employeeRange` enum value sent on create.
export const employeeRanges = [
  { id: CompanyEmployeeRange.FROM_1_TO_10, labelKey: 'onb_emp_1_10' },
  { id: CompanyEmployeeRange.FROM_10_TO_100, labelKey: 'onb_emp_10_100' },
  { id: CompanyEmployeeRange.FROM_100_TO_1000, labelKey: 'onb_emp_100_1000' },
  { id: CompanyEmployeeRange.ABOVE_1000, labelKey: 'onb_emp_1000_plus' },
];

// First INDUSTRY_PREVIEW_COUNT show by default; the rest reveal on "Show more".
export const INDUSTRY_PREVIEW_COUNT = 8;

export const industries: OnboardingOption[] = [
  { id: 'construction', labelKey: 'onb_ind_construction', icon: 'hard-hat' },
  { id: 'security', labelKey: 'onb_ind_security', icon: 'shield' },
  { id: 'health', labelKey: 'onb_ind_health', icon: 'heart-pulse' },
  { id: 'cleaning', labelKey: 'onb_ind_cleaning', icon: 'spray-can' },
  { id: 'retail', labelKey: 'onb_ind_retail', icon: 'store' },
  { id: 'food', labelKey: 'onb_ind_food', icon: 'utensils-crossed' },
  { id: 'field-services', labelKey: 'onb_ind_field_services', icon: 'wrench' },
  { id: 'manufacturing', labelKey: 'onb_ind_manufacturing', icon: 'factory' },
  { id: 'entertainment', labelKey: 'onb_ind_entertainment' },
  { id: 'transportation', labelKey: 'onb_ind_transportation' },
  { id: 'education', labelKey: 'onb_ind_education' },
  { id: 'real-estate', labelKey: 'onb_ind_real_estate' },
];

export const features: OnboardingOption[] = [
  { id: 'projects', labelKey: 'onb_feat_projects', icon: 'folder-kanban' },
  { id: 'tasks', labelKey: 'onb_feat_tasks', icon: 'square-check-big' },
  { id: 'inspections', labelKey: 'onb_feat_inspections', icon: 'clipboard-check' },
  { id: 'form-templates', labelKey: 'onb_feat_form_templates', icon: 'clipboard-list' },
  { id: 'attendance', labelKey: 'onb_feat_attendance', icon: 'calendar-check' },
  { id: 'tickets', labelKey: 'onb_feat_tickets', icon: 'ticket' },
  { id: 'data-source', labelKey: 'onb_feat_data_source', icon: 'database' },
  { id: 'data-structure', labelKey: 'onb_feat_data_structure', icon: 'network' },
  { id: 'activity-log', labelKey: 'onb_feat_activity_log', icon: 'scroll-text' },
  { id: 'people', labelKey: 'onb_feat_people', icon: 'users' },
  { id: 'groups', labelKey: 'onb_feat_groups', icon: 'users-round' },
  { id: 'roles', labelKey: 'onb_feat_roles', icon: 'shield-check' },
];
